import { useState } from 'react'
import { Button } from '@quebon/ui/components/button'
import { LessonHistoryModal } from './LessonHistoryModal'
import { useTranslation } from 'react-i18next'
import { useLessonDetail } from '@/hooks/coaching/useLessonDetail'
import type { LessonSelectionMeta } from '@/types/coaching'
import { LessonGradingPane } from './LessonGradingPane'

interface Props {
  learnerId: number
  lessonId: number
  selectionMeta?: LessonSelectionMeta | null
  attemptScope?: 'progress' | 'review'
}

export function LessonProgressDetailPane({
  learnerId,
  lessonId,
  selectionMeta,
  attemptScope = 'progress',
}: Props) {
  const { t } = useTranslation('coaching')
  const [historyOpen, setHistoryOpen] = useState(false)
  const detail = useLessonDetail(
    learnerId,
    lessonId,
    selectionMeta?.courseId,
    selectionMeta?.moduleId,
  )

  if (detail.isLoading) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-8 text-sm text-gray-500" role="status" aria-live="polite">
        {t('lessonDetail.loading')}
      </div>
    )
  }

  if (detail.error || !detail.data) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-8 text-sm text-red-600" role="alert">
        {t('lessonDetail.loadError')}
      </div>
    )
  }

  const lesson = {
    ...detail.data.initialAttempt,
    lessonTitle: detail.data.initialAttempt.lessonTitle || detail.data.lesson.title,
  }

  return (
    <div className="flex flex-col gap-3">
      <Button variant="outline" className="self-start" onClick={() => setHistoryOpen(true)}>{t('lessonPhotos.history')}</Button>
      {historyOpen ? <LessonHistoryModal key={`${learnerId}:${lessonId}`} learnerId={learnerId} lessonId={lessonId} lessonTitle={lesson.lessonTitle} courseId={selectionMeta?.courseId} moduleId={selectionMeta?.moduleId} onClose={() => setHistoryOpen(false)} /> : null}
    <LessonGradingPane
      learnerId={learnerId}
      lesson={lesson}
      selectionMeta={selectionMeta}
      attemptScope={attemptScope}
      photoReadOnly
    />
    </div>
  )
}
